import { Gizmo } from "flowy-3-core";
import { Row } from "antd";
import { foro2025 } from "../../assets/images";

type LoginHeaderProps = {
  gizmo: Gizmo;
};

const LoginHeader = ({ gizmo }: LoginHeaderProps) => {
  return (
    <Row justify={"center"}>
      <img
        src={foro2025}
        style={{
          maxWidth: "25%",
        }}
      />
    </Row>
  );
};

export default LoginHeader;
